import { showToast } from './toast'
import { logger } from './logger'

const DEFAULT_ERROR_MESSAGE = 'Something went wrong'
const NETWORK_ERROR_MESSAGE = 'Network error — please check your connection and try again'

type CallApiNetworkMarkedError = Error & { fromCallApiNetwork?: boolean }

export function markCallApiNetworkError(err: Error): Error {
  const tagged = err as CallApiNetworkMarkedError

  tagged.fromCallApiNetwork = true

  return err
}

const isNetworkFailure = (err: unknown): boolean => {
  if (err && typeof err === 'object' && (err as CallApiNetworkMarkedError).fromCallApiNetwork) {
    return true
  }

  if (!(err instanceof TypeError)) {
    return false
  }

  return /failed to fetch|load failed|networkerror|network request failed/i.test(err.message || '')
}

export const getApiErrorMessage = (err: any, fallback: string): string => {
  if (isNetworkFailure(err)) {
    return NETWORK_ERROR_MESSAGE
  }

  return err?.payload?.message || fallback
}

export const formatApiErrorMessage = (message: string | string[] | undefined): string => {
  if (!message) {
    return DEFAULT_ERROR_MESSAGE
  }

  if (typeof message === 'string') {
    return message || DEFAULT_ERROR_MESSAGE
  }

  const formattedMessages = message.filter((msg): msg is string => typeof msg === 'string')

  return formattedMessages.length > 0 ? formattedMessages.join(', ') : DEFAULT_ERROR_MESSAGE
}

export const handleApiError = (err: any, context?: string) => {
  const errorMessage = err?.payload?.message || err?.message || 'Unknown error'
  const status = err?.status || err?.statusCode

  logger.error(context ? `${context}: ${errorMessage}` : `API Error: ${errorMessage}`, err, {
    status,
    payload: err?.payload,
    context,
  })

  if (typeof err === 'object') {
    err.slice(0, 3).forEach((item: any) => {
      const message = typeof item === 'object' ? 'Something went wrong' : item

      showToast(message, {
        variant: 'error',
        autoHideDuration: 6000,
      })
    })
  } else {
    showToast(err, {
      variant: 'error',
      autoHideDuration: 6000,
    })
  }
}
